__turbopack_context__.v({
  "button": "LIlS6W_button",
  "button--disabled": "LIlS6W_button--disabled",
  "button__next": "LIlS6W_button__next",
  "button__prev": "LIlS6W_button__prev",
  "button__transparent": "LIlS6W_button__transparent",
  "shimmer": "LIlS6W_shimmer",
  "text-bar-sweep": "LIlS6W_text-bar-sweep",
});
